export default {
    name: 'footer',
    component() {
        return {
            newsletter: {
                email: "",
                gdpr: "",
                success: false,
            },
            emailError: false,
            gdprError: false,

            init() {
                const subscribeSuccess = new URLSearchParams(window.location.search).get('customer_posted');
                const alreadySubscribed = new URLSearchParams(window.location.search).has('contact[tags]');

                if (alreadySubscribed) {
                  this.newsletter.success = true;                  
                }
            },
            
            validateNewsletter() {
                let emailInput = document.querySelector("[data-newsletter-email]");
                let gdprInput = document.querySelector("[data-newsletter-gdpr]");
                let valid = true;
        
                if (
                    this.newsletter.email !== "" &&
                    this.validateEmail(this.newsletter.email) && this.newsletter.gdpr == true
                ) {

                } else {
                    if(this.newsletter.email == "" || this.validateEmail(this.newsletter.email) == null) {
                        this.emailError = true;
                    } else {
                        this.emailError = false;
                    }

                    if(this.newsletter.gdpr != true) {
                        this.gdprError = true;
                    } else {
                        this.gdprError = true;
                    }

                    valid = false;
                }
        
                if (valid) {
                    this.submitNewsletter();
                }
            },

            submitNewsletter() {
              setTimeout(() => {
                  this.newsletter.success = true;
              }, "500");

               const form = document.querySelector("form[id='contact_form']");
               form.submit();
            },

            validateEmail(email) {
              return String(email)
                  .toLowerCase()
                  .match(
                      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                  );
            },
        }
    }
}